import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const sections = [
  {
    title: "1. Présentation de l'entreprise",
    content: (
      <>
        <p className="mb-4">Les présentes conditions régissent l'utilisation du site internet de SOMINKA.</p>
        <ul className="space-y-2 list-none pl-0 text-sm text-gray-600">
          <li><strong className="text-gray-700">Entreprise :</strong> SOMINKA</li>
          <li><strong className="text-gray-700">Dirigeante :</strong> Amelia Anna Sominka</li>
          <li><strong className="text-gray-700">Statut :</strong> Entrepreneur individuel</li>
          <li><strong className="text-gray-700">SIRET :</strong> 101 634 145 00011</li>
          <li><strong className="text-gray-700">Adresse :</strong> 4 Rue Judaïque, 33000 Bordeaux, France</li>
        </ul>
      </>
    ),
  },
  {
    title: "2. Objet du site",
    content: (
      <p>Le site présente les services de conseil proposés par SOMINKA dans le domaine de la gestion et des affaires (code NAF 70.22Z – Conseil pour les affaires et autres conseils de gestion).</p>
    ),
  },
  {
    title: "3. Informations",
    content: (
      <p>Les informations fournies sur ce site sont données à titre informatif et ne constituent pas une offre contractuelle. SOMINKA s'efforce de maintenir des informations exactes et à jour, sans toutefois garantir l'exhaustivité ou l'exactitude de celles-ci.</p>
    ),
  },
  {
    title: "4. Propriété intellectuelle",
    content: (
      <p>Tous les contenus du site sont protégés par le droit de propriété intellectuelle. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site est interdite sans l'autorisation préalable écrite de SOMINKA.</p>
    ),
  },
  {
    title: "5. Droit applicable",
    content: (
      <p>Les présentes conditions sont soumises au droit français. Tout litige relatif à l'utilisation du site sera soumis aux juridictions compétentes françaises.</p>
    ),
  },
  {
    title: "6. Contact",
    content: (
      <p>
        Pour toute question relative aux présentes conditions :{' '}
        <a href="mailto:ameliasominkaaa@outlook.com" className="text-[#1A2B4A] hover:underline">
          ameliasominkaaa@outlook.com
        </a>
      </p>
    ),
  },
];

export default function Legal() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1 pt-20">
        <section className="py-16 bg-white border-t-4 border-[#1A2B4A]">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <h1 className="font-poppins text-4xl font-semibold text-[#1A2B4A] mb-3">
              Conditions générales
            </h1>
            <p className="text-gray-500 text-sm">Dernière mise à jour : mars 2026</p>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-3xl mx-auto px-6 lg:px-8">
            <div className="space-y-10">
              {sections.map((section, i) => (
                <div key={i}>
                  <h2 className="font-poppins text-xl font-semibold text-[#1A2B4A] mb-4">
                    {section.title}
                  </h2>
                  <div className="text-gray-600 text-sm leading-relaxed">
                    {section.content}
                  </div>
                  {i < sections.length - 1 && (
                    <div className="border-b border-gray-100 mt-10"></div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-gray-100">
              <Link
                to="/"
                className="text-sm text-[#1A2B4A] hover:underline cursor-pointer"
              >
                ← Retour à l'accueil
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
